module.exports = __webpack_public_path__ + "img/c_8.b6945383.png";